import { Flex, Box, Text, Textarea, Spinner, Button } from "@chakra-ui/react";
import { useState } from "react";
import colors from "../../../utils/colors";
import { useAddOrUpdateDefinitiveDiagnosis } from "../../../apis/patients";

interface DefinitiveDiagnosisProps {
  appointmentId: string;
}

const DefinitiveDiagnosis: React.FC<DefinitiveDiagnosisProps> = ({ appointmentId }) => {
  const [note, setNote] = useState("");
  const mutation = useAddOrUpdateDefinitiveDiagnosis(appointmentId);

  const handleSubmit = () => {
    if (!note.trim()) return; 
  
    mutation.mutate(
      { definitiveDiagnosis: note },  
      {
        onSuccess: () => setNote(""), 
      }
    );
  };

  return (
    <Flex direction="column" width="100%" gap="20px">
      <Box
        backgroundColor="white"
        borderRadius="8px"
        boxShadow="1px 4px 15px 0px #3030301F"
        padding="40px"
      >
        <Text fontSize="16px" fontWeight={700} color={colors.dark} mb="12px">
          Note
        </Text>

        <Textarea
          focusBorderColor={colors.primary}
          placeholder="Enter definitive diagnosis here"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <Flex justifyContent="flex-end">
          <Button
            colorScheme="green"
            mt="20px"
            onClick={handleSubmit}
            isLoading={mutation.isPending} 
            isDisabled={!note.trim()}
          >
            Submit
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default DefinitiveDiagnosis;
